"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSelectorComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
var _APSearchInput = _interopRequireDefault(require("../common/APSearchInput/APSearchInput"));
var _useTranslationsConfig = require("../Settings/ProfileAndSecurity/RegionSettingsCard/RegionSettings/useTranslationsConfig");
require("./LanguageSelectorComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var LanguageSelectorComponent = exports.LanguageSelectorComponent = function LanguageSelectorComponent(_ref) {
  var customClass = _ref.customClass,
    isAuthenticated = _ref.isAuthenticated,
    setNewLanguage = _ref.setNewLanguage;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t,
    i18n = _useTranslation.i18n;
  var _useTranslationsConfi = (0, _useTranslationsConfig.useTranslationsConfig)(),
    options = _useTranslationsConfi.options;
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    textFilter = _useState2[0],
    setTextFilter = _useState2[1];
  var deferredText = (0, _react.useDeferredValue)(textFilter.toLowerCase());
  var bemClasses = (0, _cssClassesHelper.getBEMClasses)(['language-selector', customClass]);
  var handleFilter = (0, _react.useCallback)(function (e) {
    return setTextFilter(e.target.value);
  }, []);
  var changeLanguage = i18n.changeLanguage;
  var handleSelect = (0, _react.useCallback)(function (id) {
    setTextFilter('');
    if (isAuthenticated) {
      setNewLanguage(id);
    }
    changeLanguage(id);
  }, [setNewLanguage, isAuthenticated, changeLanguage]);
  var handleCancel = (0, _react.useCallback)(function () {
    return setTextFilter('');
  }, []);
  var reorderedLanguages = (0, _react.useMemo)(function () {
    // Position the selected language first in the array
    return options.slice().sort(function (a, b) {
      return a.value === i18n.resolvedLanguage ? -1 : b.value === i18n.resolvedLanguage ? 1 : 0;
    });
  }, [i18n.resolvedLanguage, options]);
  var filteredLanguages = (0, _react.useMemo)(function () {
    // Filter the sorted array by user input
    return reorderedLanguages.filter(function (o) {
      return o.label.toLowerCase().includes(deferredText);
    });
  }, [reorderedLanguages, deferredText]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('icon-container')
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: bemClasses('language-button')
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    customClass: bemClasses('icon'),
    name: "globe"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('floating-container')
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: bemClasses('title')
  }, t('Language')), /*#__PURE__*/_react["default"].createElement(_APSearchInput["default"], {
    value: textFilter,
    onChange: handleFilter,
    placeholder: t('Search'),
    onCancel: handleCancel
  }), /*#__PURE__*/_react["default"].createElement("ul", {
    className: bemClasses('item-list-container')
  }, filteredLanguages.map(function (o) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      key: o.value,
      className: bemClasses("language-item".concat(i18n.resolvedLanguage === o.value ? '-selected' : '')),
      onClick: function onClick() {
        return handleSelect(o.value);
      }
    }, o.label);
  })))));
};
LanguageSelectorComponent.propTypes = {
  setNewLanguage: _propTypes["default"].func.isRequired,
  customClass: _propTypes["default"].string,
  isAuthenticated: _propTypes["default"].bool
};